module.exports = __webpack_public_path__ + "static/media/pink_animal_insects_6.c37f786c.webp";